import "./Juror.css";

const Juror = ({name, title, img, bio, isOpen, setIsOpen}) =>{
    return (
        <div className = "juror">
            <div className = "JurorImage">
                <img className = "noSelect" src = {img} alt = ""/>
            </div>
            <p className = "jurorName">{name}</p>
            <p className = "jurorTitle">{title}</p>
            <div className = "jurorBio" style = {{maxHeight: isOpen 
                                                                    ? window.innerWidth > 500 ? "650px" : "450px" 
                                                                    : "2ch"}}>
                <p className = "raedMoreButtonJurors" onClick = {()=>setIsOpen(!isOpen)} >{isOpen ? "Gizle" : "Daha Fazlası"}</p>
                {bio}
            </div>
        </div>
    )
}

export default Juror;